module.exports = __webpack_public_path__ + "assets/French.a6914bce.svg";